import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const NextBtn = (props) => (
  <button className="btn btn-primary w-100 py-3" {...props}>
    {props.text}
    <ArrowForwardIcon className="ms-2" />
  </button>
)

export default NextBtn;